export default {
  methods: {

  },

  computed: {
    fileTypes () {
      return this.$store.getters['security/files']['message']['mime'].join()
    },

    fileInputLabel () {
      let size = this.$store.getters['security/files']['message']['size']/1000000
      return `${this.$t('_attachFile')} (max ${size} Mo)`
    }
  }
}
